import { createPostApiCall } from '../../../../Helpers/api'

export const tokenBySessionRoute = '/advancedreporting/api/v4/sessions'
export const findSimilarRoute = '/advancedreporting/api/v4/formulas/compilers'

const createFindSimilarFormula = (contactId, numContacts) => `
format(
  <SET_START ''; SET_END ''; SET_SEPARATOR ','; PATTERN '#'>,
  [DistinctValues OF [Call]
    WHERE isSimilarValue(
      [Call],
      ${numContacts},
      ${contactId},
      similarityFeature([Call].[duration], True, 1),
      similarityFeature([Call].[Contact Was Held], False, 1),
      similarityFeature([Call].[NPS Response], True, 1),
      similarityFeature([Call].[timeToAnswer], True, 1),
      similarityFeature([Call].[Person], False, 1)
    )
  ]
)
`

export default {
  getFindSimilar: async (contactId, numContacts, sessionId) => {
    const authTokenResponse = await createPostApiCall(tokenBySessionRoute)({ hazelcastSessionId: sessionId })
    const accessToken = authTokenResponse.access_token

    return createPostApiCall(findSimilarRoute)(
      {
        compiler: 'REPORT',
        formula: createFindSimilarFormula(contactId, numContacts),
        validation: true,
        includeIdioms: false,
        qnameDataSet: null,
        qnameSourceTable: null,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )
  },
}

export const mock = {
  getFindSimilar: async () => {
    const returnValue = {
      formulaType: 'TEXT',
      values: ['123,490,3572,3752,3932,4454,4721,5181,6228,6853'],
      schemaName: 'com.stytch.rest.api.v4.data.formula.CompileResultData',
    }
    await returnValue
    return returnValue
  },
}
